import React from 'react';

const EmailIconSvg = ({ color, opacity, size = 16 }) => (
    <svg width={size} height={size} viewBox="0 0 20 20"  fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M12.2033 16.59L16.75 4.32333C16.9975 3.655 16.3467 3.005 15.6792 3.2525L3.40833 7.8025C2.64083 8.0875 2.70083 9.1925 3.49499 9.39166L9.18999 10.8225L10.6125 16.5025C10.8125 17.2975 11.9183 17.3583 12.2033 16.59V16.59Z" stroke={color} strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M16.5583 3.44165L9.19165 10.825" stroke={color} strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
</svg>

);

const EmailIcon = ({ color, opacity, size = 16, iconDropDownList }) => {
  if (iconDropDownList && iconDropDownList.length > 0) {
    return (
      <div className="dropdown" style={{ position: 'static' }}>
        <a
          className=""
          type="button"
          data-bs-toggle="dropdown"
          data-bs-boundary="viewport"
          data-bs-offset="0,5"
          aria-expanded="false"
        >
          <EmailIconSvg color={color} opacity={opacity} size={size} />
        </a>
        <ul className="dropdown-menu dropdown-menu-end px-0">
          {iconDropDownList.map(({ label, clickHandler }, index) => (
            <li key={index} className="dropdown-item" onClick={clickHandler}>
              <span className="d-flex align-items-center pr-1" title={label}>
                {label}
              </span>
            </li>
          ))}
        </ul>
      </div>
    );
  }
  return <EmailIconSvg color={color} opacity={opacity} size={size} />;
};

EmailIcon.defaultProps = {
  size: 16,
  opacity: 1,
  color: "#323232",
};

export default EmailIcon;

